export default ({ request }) => ({
  ecomToolUploadFilesListApi(data = {}) {
    return request({
      url: '/ecom/tool/upload/files/list',
      method: 'POST',
      data,
    })
  },
  ecomToolUploadFilesDetailApi(data = {}) {
    return request({
      url: '/ecom/tool/upload/files/detail',
      method: 'POST',
      data,
    })
  },
  ecomToolUploadFilesAddApi(data = {}) {
    return request({
      url: '/ecom/tool/upload/files/add',
      method: 'POST',
      data,
    })
  },
  ecomToolUploadFilesDelApi(data = {}) {
    return request({
      url: '/ecom/tool/upload/files/del',
      method: 'POST',
      data,
    })
  },
})
